import {
  StapleTable,
  StapleTableHeader,
  StapleTableRow,
  StapleTableHeading,
  StapleTableBody,
  StapleTableCell,
} from '@insurancemenu/imenu-components-lib';
import { normDateToShortAmericanDate } from '@insurancemenu/imenu-components-lib/dist/helpers/dateFormatters';
import { getProductLinesFromArray } from '@insurancemenu/imenu-components-lib/dist/utils/ProductLinesHelper';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { TriggerRenewalsPeriod } from 'store/pages/tools/trigger-renewals/types';
import { StapleTableWrapperStyled } from './styles';

interface Props {
  periods: Pick<TriggerRenewalsPeriod, 'id' | 'groupId' | 'effectiveDate' | 'productLineIds'>[];
  groups: Array<{ id: string; name: string }>;
  changeableEffectiveDate?: React.ReactNode;
}

const PeriodsModalTable: React.FC<Props> = observer(({ periods, groups, changeableEffectiveDate }) => {
  return (
    <StapleTableWrapperStyled>
      <StapleTable totalElements={periods.length} minHeight="35rem" maxHeight="35rem">
        <StapleTableHeader>
          <StapleTableRow>
            <StapleTableHeading width="16rem">Group Name</StapleTableHeading>
            <StapleTableHeading width="14rem">Effective Date</StapleTableHeading>
            <StapleTableHeading width="16rem">Product Lines</StapleTableHeading>
          </StapleTableRow>
        </StapleTableHeader>
        <StapleTableBody>
          {periods.map((period) => {
            const groupName = groups.find((group) => group.id === period.groupId)?.name || '';
            return (
              <StapleTableRow key={period.id}>
                <StapleTableCell width="16rem">{groupName}</StapleTableCell>
                <StapleTableCell width="14rem">
                  {changeableEffectiveDate || normDateToShortAmericanDate(period.effectiveDate)}
                </StapleTableCell>
                <StapleTableCell width="16rem">{getProductLinesFromArray(period.productLineIds)}</StapleTableCell>
              </StapleTableRow>
            );
          })}
        </StapleTableBody>
      </StapleTable>
    </StapleTableWrapperStyled>
  );
});

export default PeriodsModalTable;
